import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SquareButtonComponent} from '../square-button/square-button.component';

@Component({
  selector: 'modal-install-info',
  templateUrl: './modal-install-info.component.html',
  styleUrls: ['./modal-install-info.component.scss'],
  imports: [CommonModule, SquareButtonComponent],
  standalone: true
})
export class ModalInstallInfoComponent {

  @Input() show: boolean = false;
  @Input() showCloseButton: boolean = true;
  @Input() closeOnBackdropClick: boolean = true;
  @Output() close = new EventEmitter<void>();
  @Output() install = new EventEmitter<void>();

  constructor() {
  }

  installPWA() {
    this.install.emit();
  }


  onBackdropClick(): void {
    if (this.closeOnBackdropClick) {
      this.closeModal();
    }
  }

  closeModal() {
    this.close.emit();
  }

  share() {
    if (window.navigator.share) {
      window.navigator.share({
        title: 'Hoomvip',
        url: window.location.href
      });
    }
  }
}
